/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'search': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M15.5 10.5a5 5 0 11-10 0 5 5 0 0110 0zm-.7 4.874a6.5 6.5 0 111.005-1.118l3.564 3.71a.75.75 0 01-1.081 1.039l-3.488-3.63z" _fill="#000"/>'
  }
})
